export { default } from './ErrorLayout';
